export default (function () {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/noop.js
// module id = 109
// module chunks = 0